/** Paths that must never be treated as assessment slugs */
export const RESERVED_PATHS = new Set([
  '',
  'admin',
  'api',
  'assets',
  'proctoring-test',
  'login',
  'favicon.ico',
])

const KEBAB_CASE_SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export function isValidAssessmentSlug(slug: string): boolean {
  if (!slug || slug.length > 64) return false
  if (RESERVED_PATHS.has(slug.toLowerCase())) return false
  return KEBAB_CASE_SLUG.test(slug)
}

export function normalizeAssessmentSlug(slug: string): string {
  return slug.trim().toLowerCase()
}
